/**
 * @generated SignedSource<<6b5a79b14785a6b0b7466cfaeb91c370>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type heroArticlesHomeV2Content$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"topStoriesItemV2Content">;
  readonly " $fragmentType": "heroArticlesHomeV2Content";
};
export type heroArticlesHomeV2Content$key = {
  readonly " $data"?: heroArticlesHomeV2Content$data;
  readonly " $fragmentSpreads": FragmentRefs<"heroArticlesHomeV2Content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "heroArticlesHomeV2Content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topStoriesItemV2Content"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "6589131e90918d5059dcb33dcaafa02b";

export default node;
